import React, { useState } from 'react';

const Button17 = ({
    children,
    onClick,
    variant = 'primary',
    className = '',
    disabled = false,
    type = 'button',
}) => {
    const [hovered, setHovered] = useState(false);

    const baseStyle = {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        fontSize: '13px',
        fontWeight: 500,
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        padding: '14px 32px',
        border: 'none',
        borderRadius: '0',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.3s ease',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
    };

    const variants = {
        primary: {
            default: {
                backgroundColor: '#18181B',
                color: '#FFFFFF',
                border: '1px solid #18181B',
            },
            hover: {
                backgroundColor: '#27272A',
                color: '#FFFFFF',
                border: '1px solid #27272A',
            },
        },
        outline: {
            default: {
                backgroundColor: 'transparent',
                color: '#18181B',
                border: '1px solid #18181B',
            },
            hover: {
                backgroundColor: '#18181B',
                color: '#FFFFFF',
                border: '1px solid #18181B',
            },
        },
        minimal: {
            default: {
                backgroundColor: 'transparent',
                color: '#18181B',
                border: '1px solid transparent',
                padding: '8px 0',
                textDecoration: 'underline',
                textUnderlineOffset: '4px',
            },
            hover: {
                backgroundColor: 'transparent',
                color: '#71717A',
                border: '1px solid transparent',
                padding: '8px 0',
                textDecoration: 'underline',
                textUnderlineOffset: '4px',
            },
        },
    };

    const currentVariant = variants[variant] || variants.primary;
    const variantStyle = hovered && !disabled ? currentVariant.hover : currentVariant.default;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500&display=swap');
            `}</style>
            <button
                type={type}
                onClick={disabled ? undefined : onClick}
                disabled={disabled}
                className={className}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{ ...baseStyle, ...variantStyle }}
            >
                {children}
            </button>
        </>
    );
};

export default Button17;
